<template>
  <div id="masterDataTypeManagement" class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <el-row class="flex">
        <!-- <selectStandardId @updateStandardId="updateStandardId" /> -->
        <el-input
          clearable
          v-model="typeName"
          size="small"
          :placeholder="`${$t('typeName')}`"
          class="w-200px mr-10px"
        />
        <el-input
          clearable
          v-model="className"
          size="small"
          :placeholder="`${$t('entityName')}`"
          class="w-200px mr-10px"
        />
        <el-date-picker
          v-model="datetimerange"
          size="small"
          type="datetimerange"
          :range-separator="`${$t('to')}`"
          :start-placeholder="`${$t('startDate')}`"
          :end-placeholder="`${$t('endDate')}`"
          value-format="yyyy-MM-dd HH:mm:ss"
          class="mr-10px"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="searchTableData()">{{
          $t('search')
        }}</el-button>
        <el-button size="small" @click="reset">{{ $t('reset') }}</el-button>
        <el-button
          type="primary"
          size="small"
          :disabled="!$hasAccess('create')"
          @click="addAttribute"
          >{{ $t('create') }}</el-button
        >
        <el-button type="danger" size="small" @click="delMore" :disabled="!$hasAccess('delete')">{{
          $t('delete')
        }}</el-button>
        <el-button
          size="small"
          :disabled="!$hasAccess('export')"
          @click="exportFile"
          :loading="exportLoading"
          >{{ $t('export') }}</el-button
        >
      </el-row>
      <el-table
        border
        :data="tableData"
        v-loading="tableLoading"
        :highlight-current-row="true"
        @selection-change="handleSelectionChange"
        height="calc(100% - 106px)"
        ref="multipleTable"
        class="mt-20px"
      >
        <el-table-column show-overflow-tooltip type="selection" width="55"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          :label="`${$t('typeName')}`"
          prop="typeName"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          :label="`${$t('mainDatadescription')}`"
          prop="description"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          :label="`${$t('bindingEntities')}`"
          prop="className"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          :label="`${$t('remarks')}`"
          prop="remark"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          :label="`${$t('creationTime')}`"
          prop="createdTime"
        ></el-table-column>
        <el-table-column :label="`${$t('operate')}`" show-overflow-tooltip width="160">
          <template slot-scope="scope">
            <el-button
              :disabled="!$hasAccess('update')"
              @click.stop="editAttr(scope.row)"
              size="mini"
              >{{ $t('edit') }}</el-button
            >
            <el-button
              :disabled="!$hasAccess('delete')"
              @click.stop="delAttr(scope.row)"
              size="mini"
              >{{ $t('delete') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px float-right"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        :page-sizes="$pageSizeAll"
        layout="total, sizes, prev, pager, next, jumper"
        :total="recordCount"
      ></el-pagination>
      <el-dialog
        :title="dialogTitle"
        :visible.sync="attrDialog"
        @close="queryFormClose"
        :close-on-click-modal="false"
        class="small-dialog"
        v-dialogDrag
      >
        <el-form
          label-width="120px"
          ref="queryForm"
          :rules="queryFormRules"
          :model="queryForm"
          label-position="right"
        >
          <el-row :gutter="20" class="pl-10px pr-20px">
            <el-col :span="24">
              <el-form-item :label="`${$t('typeName')}`" prop="typeName" class="w-full">
                <el-input size="small" clearable v-model.trim="queryForm.typeName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="`${$t('mainDatadescription')}`"
                prop="description"
                class="w-full"
              >
                <el-input
                  size="small"
                  clearable
                  v-model.trim="queryForm.description"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="24">
              <el-form-item label="标准" prop="standardId">
                <el-select
                  size="small"
                  class="w-full"
                  v-model="queryForm.standardId"
                  filterable
                  placeholder="标准"
                >
                  <el-option
                    v-for="item in standardList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="绑定实体" prop="classInfo">
                <el-select
                  v-model="queryForm.classInfo"
                  filterable
                  clearable
                  :placeholder="`${$t('pleaseSelect')}`"
                  class="w-full"
                  size="small"
                  multiple
                  collapse-tags
                >
                  <el-option
                    v-for="(item, index) in classList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="24">
              <el-form-item :label="`${$t('remarks')}`" prop="remark" class="w-full">
                <el-input size="small" v-model.trim="queryForm.remark" type="textarea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer tc">
          <el-button
            type="primary"
            size="small"
            @click="queryFormSave('queryForm')"
            :loading="isLoading"
            >{{ $t('save') }}</el-button
          >
          <el-button size="small" @click="queryFormClose">{{ $t('cancel') }}</el-button>
        </div>
      </el-dialog>
      <upload-excel
        ref="excel"
        :customization="true"
        excelType="std/StdAttribute"
        @refreshList="searchTableData"
      ></upload-excel>
    </el-card>
  </div>
</template>
<script>
import uploadExcel from '@/components/upload'
import StandardManagementService from '@/services/common/StandardManagementService'
import MasterDataManageService from '@/services/masterDataManageService'
import stdClassListService from '@/services/stdClassListService'
import fnMixin from '@/assets/js/fnMixins'
// import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'masterDataTypeManagement',
  components: {
    uploadExcel,
    // selectStandardId,
  },
  data() {
    return {
      standardList: [],
      standardId: localStorage.getItem('standardId'),
      code: '',
      name: '',
      dataTypeList: [],
      dataTypeId: '',
      associativeMetadata: '',
      datetimerange: [],
      totalSelection: [],
      dialogTitle: '新增',
      pageNo: 1,
      pageSize: 10,
      recordCount: 0,
      tableLoading: false,
      tableData: [],
      queryForm: {
        typeName: '',
        description: '',
        // standardId: localStorage.getItem('standardId'),
        // classId: [],
        remark: '',
        // classInfo: [],
      },
      keyword: '',
      attrDialog: false,
      queryFormRules: {
        typeName: [{ required: true, message: '请输入类型名称', trigger: 'blur' }],
        // description: [{ required: true, message: '请输入类型描述', trigger: 'blur' }],
        classInfo: [
          {
            required: true,
            message: '请选择实体',
            trigger: 'blur',
          },
        ],
        standardId: [{ required: true, message: '请选择标准', trigger: 'blur' }],
      },
      classList: [],
      isLoading: false,
      className: '', // 实体名称
      typeName: '', // 类型名称
      exportLoading: false,
    }
  },
  watch: {
    async standardId(val) {
      if (val) {
        await this.searchTableData()
      }
    },
    'queryForm.standardId': {
      handler(newValue) {
        this.queryForm.classInfo = []
        if (newValue) {
          this.getClassList()
        } else {
          this.classList = []
          this.classId = ''
        }
      },
    },
    'queryForm.typeName': {
      handler(newVal) {
        this.queryForm.description = newVal
      },
    },
    attrDialog(val) {
      if (!val) {
        this.$refs.queryForm.clearValidate()
        this.$refs.queryForm.resetFields()
      }
    },
  },
  async created() {
    this.searchTableData()
    // this.getClassList()
    // this.getStandardList()
  },
  methods: {
    updateStandardId(val) {
      this.standardId = val
      this.queryForm.standardId = val
    },
    handleSelectionChange(val) {
      // _.forEach(this.totalSelection, (item) => {
      //   if (_.find(this.tableData, ['id', item.id])) {
      //     this.totalSelection = _.difference(this.totalSelection, [item])
      //   }
      // })
      // this.totalSelection = [...this.totalSelection, ...val]
      this.totalSelection = val
    },
    proving(e) {
      const keyNum = window.event ? e.keyCode : e.which
      if (keyNum === 190 || keyNum === 110) {
        e.target.value = ''
      }
    },
    async getStandardList() {
      const res = await StandardManagementService.getList()
      if (res && res.data && res.code === 0) {
        this.standardList = res.data
      }
    },

    // 获取值类型列表
    async getClassList() {
      const parameter = {
        standard_id: this.queryForm.standardId,
        keyword: '',
        pageno: 1,
        pagesize: 999,
        data_type: 1,
        parent_id: '',
        approve_status: 1,
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.classList = res.data
      }
    },
    addAttribute() {
      this.attrDialog = true
      this.dialogTitle = '新增'
    },
    async searchTableData() {
      this.tableLoading = true
      const parameter = {
        // StandardId: this.standardId,
        ClassName: this.className,
        TypeName: this.typeName,
        SkipCount: this.pageNo,
        MaxResultCount: this.pageSize,
        Sorting: '',
      }
      parameter.StartDate = this.datetimerange === null ? '' : this.datetimerange[0]
      parameter.EndDate = this.datetimerange === null ? '' : this.datetimerange[1]
      const res = await MasterDataManageService.getList(parameter)
      this.tableLoading = false
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        this.tableData = res.data
        _.forEach(this.tableData, (item) => {
          if (_.find(this.totalSelection, ['id', item.id])) {
            this.$nextTick(() => {
              this.$refs.multipleTable.toggleRowSelection(item, true)
            })
          }
        })
        this.recordCount = res.totalCount
        this.$nextTick(() => {
          if (this.$refs.multipleTable) {
            this.$refs.multipleTable.doLayout()
          }
        })
      } else {
        this.tableData = []
        this.totalCount = 0
      }
    },
    async exportFile() {
      this.exportLoading = true
      const res = await MasterDataManageService.exportMasterDataType({
        ids: _.map(this.totalSelection, (item) => {
          return item.id
        }),
        standardId: this.standardId,
        className: this.className,
        startDate: this.datetimerange === null ? '' : this.datetimerange[0],
        endDate: this.datetimerange === null ? '' : this.datetimerange[1],
      })
      this.exportLoading = false
      if (res) {
        const time = fnMixin.methods.getNowTime()
        fnMixin.methods.downLoadExcel(`主数据类型${time}`, res)
      }
    },
    reset() {
      this.typeName = ''
      this.className = ''
      this.datetimerange = []
      this.tableData = []
      this.searchTableData()
    },
    delAttr(item) {
      this.$confirm(this.$t('confirmDeleteAttribute'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      })
        .then(async () => {
          const res = await MasterDataManageService.deleteMasterDataType([item.id])
          if (res && res.code === 0) {
            this.$message({
              type: 'success',
              message: '删除成功',
            })
            if (this.tableData.length === 1 && this.pageNo > 1) {
              this.pageNo -= 1
            }
            this.searchTableData()
          }
        })
        .catch(() => {})
    },
    delMore() {
      if (!this.totalSelection.length) {
        this.$message({
          type: 'warning',
          message: '请选择要删除的数据!',
        })
        return
      }
      const ids = this.totalSelection.map((item) => {
        return item.id
      })
      this.$confirm('是否确定要删除所选数据!', this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      })
        .then(async () => {
          const res = await MasterDataManageService.deleteMasterDataType(ids)
          if (res && res.code === 0) {
            this.$message({
              type: 'success',
              message: '删除成功',
            })
            if (this.tableData.length === 1 && this.pageNo > 1) {
              this.pageNo -= 1
            }
            this.searchTableData()
          }
        })
        .catch(() => {})
    },
    async editAttr(item) {
      this.queryForm = _.cloneDeep(item)
      const classId = _.map(this.queryForm.classInfo, (cItem) => {
        return cItem.classId
      })
      this.$set(this.queryForm, 'classInfo', classId)
      this.dialogTitle = '编辑'
      this.attrDialog = true
    },
    queryFormSave() {
      this.$refs.queryForm.validate((valid) => {
        if (valid) {
          // this.queryForm.classInfo = []
          // _.map(this.queryForm.classId, (item) => {
          //   _.map(this.classList, (cItem) => {
          //     if (item === cItem.id) {
          //       this.queryForm.classInfo.push({
          //         id: cItem.id,
          //         name: cItem.name,
          //       })
          //     }
          //   })
          // })
          // this.queryForm.classInfo = JSON.stringify(this.queryForm.classInfo)
          this.isLoading = true
          if (this.dialogTitle === '新增') {
            this.save()
          } else {
            this.update()
          }
        }
      })
    },
    async save() {
      const res = await MasterDataManageService.createMasterDataType(this.queryForm)
      if (res && res.code === 0) {
        this.$message({
          message: '新增成功',
          type: 'success',
        })
        this.attrDialog = false
        this.searchTableData()
      }
      this.isLoading = false
    },
    async update() {
      const res = await MasterDataManageService.editMasterDataType(this.queryForm)
      if (res && res.code === 0) {
        this.$message({
          message: '修改成功',
          type: 'success',
        })
        this.attrDialog = false
        this.searchTableData()
      }
      this.isLoading = false
    },
    queryFormClose() {
      this.attrDialog = false
      this.queryForm = this.$options.data().queryForm
    },
    handleCurrentChange(num) {
      this.pageNo = num
      this.searchTableData()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.searchTableData()
    },
  },
}
</script>
<style lang="scss" scoped>

#masterDataTypeManagement {
  /deep/.el-form--label-left .el-form-item__label {
    text-align: right;
  }
  .formHeight {
    height: 45px;
  }
  .titleBox {
    justify-content: space-between;
    align-items: center;
  }
  .divider {
    height: 1px;
    border-bottom: 1px solid #dcdcdc;
    flex: 1;
  }
}

</style>
